import DOMPurify from "isomorphic-dompurify"

import { getPaths } from "src/helpers/paths"

// Paths of all webshop pages in both languages, without trailing slash, so
// links like "/de/store-de" and "/de/store-de/?id=1" are matched as well.
const storePaths = [
  ...getPaths("shop"),
  ...getPaths("shopDetails"),
  ...getPaths("cart"),
].map((path) => path.replace(/\/$/, ""))

const isStoreLink = (href: string) =>
  storePaths.some((path) => href.includes(path))

/**
 * Sanitizes Wordpress HTML and removes all links to the webshop. Used when the
 * webshop is disabled (ENABLE_WEBSHOP="false"). The links are removed before
 * rendering, so they never show up, not even briefly.
 */
export const sanitizeWithoutStoreLinks = (html: string) => {
  const fragment = DOMPurify.sanitize(html, { RETURN_DOM_FRAGMENT: true })
  fragment.querySelectorAll("a[href]").forEach((link) => {
    if (isStoreLink(link.getAttribute("href") ?? "")) {
      link.remove()
    }
  })
  const container = fragment.ownerDocument.createElement("div")
  container.appendChild(fragment)
  return container.innerHTML
}
